const linkData = {
  select_val_preview: '',
  linkType: 'inside_link',// 链接类型
  isOpen: [],// // 是否在新页面打开
  none: {},// 无
  inside_link: { // 【站内链接】
    type: 'section',// 站内链接类型
    section: { // 【栏目】
      value: {} // 选择的是哪个网站栏目
    },
    product: { // 【产品】
      value: {} // 选择的是哪个产品
    },
    article: { // 【新闻】
      value: {} // 选择的是哪个新闻
    },
    case: { // 【案例】
      value: {} // 选择的是哪个案例
    },
    help: { // 【帮助】
      value: {} // 选择的是哪个帮助
    },
    product_type: { // 【产品分类】
      value: {} // 选择的是哪个产品分类
    },
    article_type: { // 【新闻分类】
      value: {} // 选择的是哪个新闻分类
    },
    case_type: { // 【案例分类】
      value: {} // 选择的是哪个案例分类
    },
    help_type: { // 【帮助分类】
      value: {} // 选择的是哪个帮助分类
    }
  },
  fun: { // 【功能】
    type: 'submit_form',
    submit_form: { // 【提交表单】
      value: ''  // 选择的表单
    },
    customer_service: { // 【客服】
      value: '' // 选择的客服
    },
    telephone_advisory: { // 【电话咨询】
      value: '' // 电话号码
    },
    information_advisory: { // 【信息咨询】
      value: '' // 联系电话
    },
    file_download: { // 【文件下载】
      url: '', // 文件地址
      name: ''
    },
    jump_section: { // 【跳到通栏/模块锚点】
      type: 'cur_page', // 跳转类型
      cur_page_value: '', // 当前页面锚点
      other_page_value: '', // 其他页面锚点
      site_section: {} //网站栏目
    },
    pop_video: { // 【弹窗视频】
      type: 'local_add', // 文件类型
      local_add: { // 【本地添加】
        url:  '', // 自定义链接地址
        name: ''
      },
      common_code: {// 【通用代码】
        url: '' // 通用代码
      },
      video_address: { // 【视频地址】
        url: '' // 视频地址
      }
    },
    // 功能发送邮件 
    send_email: {
      recipient: '', // 收件人
      subject: '', // 邮件主题
      content: '' // 邮件正文
    }
  },
  outside_link: { // 【站外链接】
    nofollow: [],
    url: '' //自定义地址
  }
}
export default linkData



// WEBPACK FOOTER //
// ./src/base/linkData.js